var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtractALarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 94,
    viewBox: "0 0 24 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9997 0H20.0266H19.7993L19.5922 0.0937032L0.619261 8.67902L0 8.95924V9.63895V19.8821V21.4241L1.43654 20.8637L18.973 14.023V92.9462V93.9998H20.0266H23.9997V92.9462H21.0802H20.0266V91.8925V13.6119V12.481L18.973 12.892L2.10726 19.4711L1.05363 19.8821V18.7512V9.63895L20.0266 1.05363H23.9997V0Z",
    fill: "#D9D9DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractALarge);
export default __webpack_public_path__ + "static/media/subtract-a-large.1ef13aa5d2520ca77b05775a046f61d1.svg";
export { ForwardRef as ReactComponent };